import { render } from "./Resignation.vue?vue&type=template&id=5f08522e&scoped=true"
import script from "./Resignation.vue?vue&type=script&lang=js"
export * from "./Resignation.vue?vue&type=script&lang=js"

import "./Resignation.vue?vue&type=style&index=0&id=5f08522e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f08522e"]])

export default __exports__